"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectSummary = void 0;
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var styled_components_1 = __importDefault(require("styled-components"));
var SelectSummaryPill_1 = require("./SelectSummaryPill");
var SummaryContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var SelectSummary = /** @class */ (function (_super) {
    __extends(SelectSummary, _super);
    function SelectSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnDismiss = _this.handleOnDismiss.bind(_this);
        _this.updateSelected = _this.updateSelected.bind(_this);
        return _this;
    }
    SelectSummary.prototype.render = function () {
        var _this = this;
        return (React.createElement(SummaryContainer, null, this.props.selected !== undefined
            ? this.props.selected.map(function (option, index) {
                return _this.props.enableDismiss && !option.disabled ? (React.createElement(SelectSummaryPill_1.SelectSummaryPill, { item: option, isDismissable: true, onDismiss: _this.handleOnDismiss, key: index })) : (React.createElement(SelectSummaryPill_1.SelectSummaryPill, { item: option, key: index }));
            })
            : null));
    };
    SelectSummary.prototype.handleOnDismiss = function (dismissed) {
        if (this.props.updateSelect !== undefined) {
            var updatedSelected = this.updateSelected(dismissed);
            this.props.updateSelect(updatedSelected);
        }
    };
    SelectSummary.prototype.updateSelected = function (dismissed) {
        return lodash_1.default.filter(this.props.selected, function (option) { return option.name !== dismissed.name; });
    };
    SelectSummary.defaultProps = {
        enableDismiss: false,
        selected: [],
    };
    return SelectSummary;
}(React.Component));
exports.SelectSummary = SelectSummary;
var templateObject_1;
